import $ from 'jquery'
import Splide from '@splidejs/splide'
import Cookies from 'js-cookie'

if ( $('.hero__slider').length != 0 ) {
  var heroSplide = new Splide( '.hero__slider', {
    perPage: 1,
    perMove: 1,
    type  : 'fade',
    rewind: true,
    pagination: false,
    arrows: false,
    autoplay: true,
    pauseOnHover: false,
  } );

  heroSplide.mount();
}

$('.hero').on( 'click', function () {
  Cookies.set('homeSliderVisited', 1)
  $('.hero').fadeOut( 500, 'linear' )
} )

var logo = $('.js-menu-logo')
var logoText = $('.js-logo-text')

logoText.hide()
logo.on( 'mouseenter', function () {
  logoText.slideDown()
} )
logo.on( 'mouseleave', function () {
  logoText.slideUp()
} )

var projects = $('.js-project')

projects.on( 'mouseenter', function () {
  if ($(window).width() >= 992) {
    $(this).addClass('is-active');
  }
} )

projects.on( 'mouseleave', function () {
  $(this).removeClass('is-active')
} )
